export default __webpack_public_path__ + "static/media/watchmadd.2f1b80b3.jpg";